import React, { FC, useState, useEffect, useRef } from 'react';
// import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';

import bg from 'assets/bg-1.svg';

import HomeAppBar from 'components/home/TopAppBar';
import BannerSection from 'components/home/BannerSection';
import InvoiceSection from 'components/home/InvoiceSection';
import InvoiceAwardSection from 'components/home/InvoiceAwardSection';

import VoteSection from 'components/home/VoteSection';

import { ApiResponse, InvoiceFormValues, VoteData, VoteFormValues } from 'types';
import { getVoteData, registerInvoice, vote } from 'utils/api';
import WinnerSection from 'components/home/WinnerSection';
import NoticeSection from 'components/home/NoticeSection';
import { VoteOption } from 'constants/enums';
import { isDateStringValid, isNumberValid, isValidEmail } from 'utils';
import FloatingButton from 'components/home/FloatingButton';

const useStyles = makeStyles((theme) => ({
	content: {
		width: '100%',
		backgroundImage: `url(${bg})`,
		backgroundSize: 'contain',
		paddingBottom: 32
	},
	banner: {
		'& img': {
			width: '100%',
			height: 'auto',
			objectFit: 'contain',
			marginTop: 0,
			marginBottom: 0,
		}
	},
	link: {
		color: '#61dafb',
	},
}));


export const Home: FC = () => {
	const [voteData, setVoteData] = useState<VoteData | null>(null); // key with red and white
	const [error, setError] = useState<string>('');
	const classes = useStyles();

	const voteRef = useRef<HTMLDivElement>(null);
	const rulesRef = useRef<HTMLDivElement>(null);
	const winnerRef = useRef<HTMLDivElement>(null);
	const invoiceRef = useRef<HTMLDivElement>(null);
	const noiceRef = useRef<HTMLDivElement>(null);

	// return result of vote()
	const submitVoteForm = async (form: VoteFormValues): Promise<ApiResponse> => {
		// valid form
  		const { option, reason, name, phone, email, idLast5 } = form;
		let errors = []

		// 檢查所有欄位是否存在
		if (!option || !reason || !name || !phone || !email || !idLast5) {
			errors.push('請完整填寫所有欄位')
		}

		// 檢查 option 是否為合法選項
		if (!!option && ![VoteOption.RED, VoteOption.WHITE].includes(option)) {
			errors.push('投票選項不正確')
		}

		// 檢查 email 格式
		if (!!email && !isValidEmail(email)) {
			errors.push('Email 格式不正確')
		}

		if (errors.length > 0) {
			return {
				isSent: false,
				isSuccess: false,
				message: errors.join('\n')
			} as ApiResponse;
		}

		const result = await vote(form);
		fetchVoteData();
		return result
	}

	const submitInvoiceForm = async (form: InvoiceFormValues): Promise<ApiResponse> => {
  		const { type, number, date, code, name, phone, email, zipcode, address, filesUrl } = form;
		let errors = []
		
		if (!filesUrl) {
			errors.push('請上傳發票檔案')
		}

		if (!type || !number || !date || !name || !phone || !email || !zipcode || !address) {
			errors.push('請完整填寫所有欄位')

		}
		if (!!type && !['paper', 'cloud'].includes(type)) {
			errors.push('請上傳發票檔案')
		}

		if (!!date && !isDateStringValid(date)) {
			errors.push('日期格式錯誤，請使用 yyyy/mm/dd')
		}

		if (!!number && !isNumberValid(number)) {
			errors.push('發票號碼格式不正確')
		}

		if (!!email && !isValidEmail(email)) {
			errors.push('Email 格式不正確')
		}

		if (errors.length > 0) {
			return {
				isSent: false,
				isSuccess: false,
				message: errors.join('\n')
			} as ApiResponse;
		}

		const result = await registerInvoice(form);
		return result
	}
	
	const fetchVoteData = async () => {
		try {
			const data = await getVoteData();
			setVoteData(data);
		} catch (err) {
			setError('Failed to fetch vote data');
		}
	};

	useEffect(() => {
		fetchVoteData();
	}, []);

	return (<>
		<HomeAppBar {... { voteRef, rulesRef, winnerRef, invoiceRef, noiceRef }}/>
		<div className={ classes.content }>
			<FloatingButton targetRef={voteRef}/>
			<BannerSection 
				redCount={voteData?.red} whiteCount={voteData?.white} 
				submitVoteForm={submitVoteForm } voteRef={voteRef}
			/>
			<InvoiceSection submitInvoiceForm={submitInvoiceForm} titleRef={invoiceRef} rulesRef={rulesRef}/>
			<InvoiceAwardSection />
			<VoteSection/>
			<WinnerSection titleRef={winnerRef}/>
			<NoticeSection titleRef={noiceRef}/>
		</div>
	</>);
};
